import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Discover Keywords\"}}\n\n<Settings::NwKeywordSuggestions\n  @url={{this.url}}\n  @keywordSuggestions={{@model}}\n/>")